// extracted by mini-css-extract-plugin
export var table = "_x7-0";